export const defaultUser = {
  first_name: "Wasiu",
  last_name: "Odumosu",
  avatarUrl: "https://randomuser.me/api/portraits/",
  role: "Aggregator",
};
